import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { fetchViewsApi } from "../../API/API";

function* fetchViewsSaga(action) {
  try {
    const response = yield call(() => fetchViewsApi());
    yield put({ type: types.GET_VIEWS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_VIEWS_FAILURE, error });
  }
}

export function* watchFetchViewsSaga() {
  yield takeEvery(types.GET_VIEWS_REQUESTED, fetchViewsSaga);
}
